/*
  Printeo — article du Journal (lot D).
  Marque dans le sommaire la partie en cours de lecture (aria-current sur les liens des deux
  sommaires, replié et latéral). Le sommaire est calculé par le serveur et fonctionne sans ce
  script : celui-ci n'ajoute que le repère visuel. Aucun texte affiché, aucune dépendance.
*/
(() => {
  const liens = Array.from(document.querySelectorAll('[data-pt-sommaire] a[href^="#"]'));
  if (!liens.length) return;

  const parties = [];
  const parId = new Map();
  for (const lien of liens) {
    let id = '';
    try {
      id = decodeURIComponent(lien.getAttribute('href').slice(1));
    } catch (erreur) {
      id = lien.getAttribute('href').slice(1);
    }
    const cible = id ? document.getElementById(id) : null;
    if (!cible) continue;
    if (!parId.has(id)) {
      const partie = { cible, liens: [] };
      parId.set(id, partie);
      parties.push(partie);
    }
    parId.get(id).liens.push(lien);
  }
  if (!parties.length) return;

  let courante = null;
  let attente = false;

  const marquer = () => {
    attente = false;
    const seuil = window.innerHeight * 0.3;
    let trouvee = null;
    for (const partie of parties) {
      if (partie.cible.getBoundingClientRect().top <= seuil) trouvee = partie;
      else break;
    }
    if (trouvee === courante) return;
    if (courante) courante.liens.forEach((lien) => lien.removeAttribute('aria-current'));
    if (trouvee) trouvee.liens.forEach((lien) => lien.setAttribute('aria-current', 'true'));
    courante = trouvee;
  };

  const demander = () => {
    if (attente) return;
    attente = true;
    window.requestAnimationFrame(marquer);
  };

  window.addEventListener('scroll', demander, { passive: true });
  window.addEventListener('resize', demander, { passive: true });
  marquer();
})();
